import { CheckCircle, SlashCircle01, Tool02 } from "@untitledui/icons";
import type { FC } from "react";
import { VehicleConditionsType } from "@/constants/vehicleConditions.enum";
import { cx } from "@/utils/cx";
import type { Question } from "../types";

const baseIconClass =
	"text-2xl text-utility-gray-600 group-hover/option-input:text-utility-gray-800 group-active/option-input:text-utility-gray-800";

const ICON_MAP: Record<VehicleConditionsType, FC<{ className?: string }>> = {
	[VehicleConditionsType.REGULAR]: CheckCircle,
	[VehicleConditionsType.DAMAGED]: Tool02,
	[VehicleConditionsType.NOT_AVAILABLE]: SlashCircle01,
};

type IconQuestionProps = {
	question: Question;
	value?: string;
	onChange?: (val: string) => void;
	error?: boolean;
};

export const IconQuestion = ({
	question,
	value,
	onChange,
	error = false,
}: IconQuestionProps) => {
	const selected = value ?? "";

	return (
		<div className="flex flex-1 flex-wrap gap-2">
			{question.options.map((item) => {
				const isSelected = selected === String(item.id);
				const Icon = ICON_MAP[item.label as VehicleConditionsType];

				return (
					<label
						className={cx(
							"group/option-input flex flex-1/5 cursor-pointer flex-col items-center justify-center gap-1",
							"rounded border border-primary bg-primary p-2 pt-3",
							!!error && "border-error",
							!!isSelected && "border-2 border-brand bg-brand-secondary"
						)}
						key={item.id}
					>
						<input
							checked={isSelected}
							className="hidden"
							name={`question_${question.questionId}`}
							onChange={() => onChange?.(String(item.id))}
							type="radio"
							value={item.id}
						/>

						{!!Icon && (
							<Icon
								className={cx(
									baseIconClass,
									!!isSelected && "text-utility-gray-800"
								)}
							/>
						)}

						<span
							className={cx(
								"text-secondary text-sm",
								!!isSelected && "font-semibold text-primary"
							)}
						>
							{item.label}
						</span>
					</label>
				);
			})}
		</div>
	);
};
